'use strict';

/**
 * @classname AnchorCartDelete
 * @classdesc カート商品削除
 */
export default class AnchorCartDelete {
	/**
	 * @constructor
	 * @param {jQuery} $e - .anchor--cart-delete
	 * @param {instance} controller - controllerオブジェクト
	 */
	constructor($e, controller) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._stockId = $e.closest('.list__item').attr('data-stock-id');
		this._controller = controller;
		$e.on('click', () => this.onClick());
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof AnchorCartDelete
	 * @return undefined
	 */
	onClick() {
		console.log(`${this.constructor.name}.onClick`);

		if(window.dataLayer){
			// GA4 設定
			const items = {
				item_name: this._$e.attr('data-item-name'),
				item_id: this._$e.attr('data-item-id'),
				price: parseInt(this._$e.attr('data-price')),
				item_category: this._$e.attr('data-category'),
				currency: this._$e.attr('data-currency'),
				discount: parseInt(this._$e.attr('data-discount')),
				quantity: parseInt(this._$e.closest('.block__item--cart-quantity').find('.quantity').val())
			}
			// カテゴリー2があったら追加
			if(this._$e.attr('data-category2') && this._$e.attr('data-category2') !== '') {
				items.item_category2 = this._$e.attr('data-category2');
			}
			// カテゴリー3があったら追加
			if(this._$e.attr('data-category3') && this._$e.attr('data-category3') !== '') {
				items.item_category3 = this._$e.attr('data-category3');
			}
			// バリエーションがあったら追加
			if(this._$e.attr('data-item-variant')){
				items.item_variant = this._$e.attr('data-item-variant');
			}

			console.log(items);

			window.dataLayer.push({
				event: "remove_from_cart",
				ecommerce: {
					items: [
						items
					]
				},
				'eventCallback': () => {
					// DataLayerにデータを送信後に通常処理へ
					this._controller.CartDelete(this._stockId);
				},
				'eventTimeout' : 2000
			});
			// timeoutしたらそのまま遷移
			setTimeout(() => {
				this._controller.CartDelete(this._stockId);
			}, 2500);
		}else{
			// dataLayerがない場合はそのまま通常処理へ
			this._controller.CartDelete(this._stockId);
		}
	};
};
